<template>
	<div v-show="show_loading">
		<div class="loading">
			<div id="loader"></div>
			<div id="loaderProgress">
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaymentMethodPix',
	data(){
		return{
		}
	},

	components: { },

	mounted: function(){},

	computed: {
		show_loading(){
			return this.$store.state.boleto.show_loading;
		},
	},

	methods: { },

	filters: { },
}
</script>
